<template>
  <div>
    <WaitingForApproval />
  </div>
</template>

<script>
import WaitingForApproval from "@/components/dashboard/pages/waiting-for-approval/WaitingForApproval";

export default {
  name: "LimeLoansWaitingForApprovalPage",

  components: { WaitingForApproval },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
